import { getHttpErrorStatus } from '../errors/http-error';
import { getHttpErrorCode } from '../errors/http-error';

const mfaEnrollmentRequiredCode = 'mfaEnrollmentRequired';

function isMfaEnrollmentRequiredError(error: unknown): boolean {
  return getHttpErrorStatus(error) === 403 && getHttpErrorCode(error) === mfaEnrollmentRequiredCode;
}

function notifyMfaEnrollmentRequired(): void {
  // Hard gate on purpose: product SessionLoader only HTML-redirects to account
  // enroll on document navigation. Full reload of this URL discards unsaved SPA
  // state so a gated tab cannot keep working mid-app.
  if (typeof window !== 'undefined') {
    window.location.assign(window.location.pathname + window.location.search + window.location.hash);
  }
}

async function notifyMfaEnrollmentRequiredFromResponse(response: Response): Promise<boolean> {
  let notified = false;
  if (response.status === 403) {
    let code: string | null = null;
    try {
      const body = (await response.clone().json()) as { code?: unknown };
      if (typeof body.code === 'string') {
        code = body.code;
      }
    } catch {} // Body may not be JSON — leave code null and fall through
    if (code === mfaEnrollmentRequiredCode) {
      notifyMfaEnrollmentRequired();
      notified = true;
    }
  }
  return notified;
}

export { mfaEnrollmentRequiredCode };
export { isMfaEnrollmentRequiredError };
export { notifyMfaEnrollmentRequired };
export { notifyMfaEnrollmentRequiredFromResponse };
